import { IconButton, Skeleton, Stack, Tooltip, Typography } from '@mui/material'
import HelpOutlineIcon from '@mui/icons-material/HelpOutline'
import React from 'react'
import ChartBarIcon from '@/components/icons/ChartBarIcon'

interface StaticCardProps {
  title: string
  helperText?: string
  value: string | number
  type?: 'percent' | 'default'
  showChartIcon?: boolean
  isLoading?: boolean
}

const StaticCard: React.FC<StaticCardProps> = ({
  title,
  value,
  type,
  helperText,
  showChartIcon,
  isLoading,
}) => {
  return (
    <div className="tw-border tw-rounded-2xl tw-shadow-md tw-p-6 tw-flex tw-flex-col tw-gap-2 tw-justify-between">
      <Stack direction="row" alignItems="center" justifyContent="space-between">
        <Typography variant="body3" color="textGrey" sx={{ fontWeight: 700 }}>
          {title}
        </Typography>
        {helperText && (
          <Tooltip placement="top" title={helperText}>
            <IconButton size="small">
              <HelpOutlineIcon color="primary" fontSize="small" />
            </IconButton>
          </Tooltip>
        )}
      </Stack>

      <Stack direction="row" justifyContent="space-between" alignItems="center">
        {isLoading ? (
          <Skeleton variant="text" width="60%" height={40} />
        ) : (
          <Typography variant="h6" component="h5">
            {value}
            {type === 'percent' ? '%' : ''}
          </Typography>
        )}
        {showChartIcon && <ChartBarIcon />}
      </Stack>
    </div>
  )
}

export default StaticCard
